import React from 'react'
import { ConversationData } from './conversation'
import { ControlledModal } from '../../../layouts/components/modal'
import { UserSelector } from '../../../components/userSelector/userSelector'
import { Button } from '../../../components/simple/button'
import { BasicUser } from '../../../components/userSelector/users'
import { SharedSingleTeacherRecipient } from '../compose/composeTypes'
import { makeRequest, showAxiosErrorAsToast } from '../../../request'

interface ConversationShareProps {
  conversation: ConversationData
  onShare: () => void
  onClose: () => void
}

export const ConversationShare: React.FC<ConversationShareProps> = ({ conversation, onShare, onClose }) => {
  const [sharedUsers, setSharedUsers] = React.useState<SharedSingleTeacherRecipient[]>([])
  const [loading, setLoading] = React.useState(false)
  const searchData = React.useMemo(
    () => ({
      message: conversation.id,
    }),
    [conversation.id]
  )
  return (
    <ControlledModal
      size="sm"
      open={true}
      onOpenChange={(o) => {
        if (!o) onClose()
      }}
      title={`Share this thread with ${conversation.isShared ? 'additional' : ''} teachers`}
      disabled={loading}
      className="gap-4"
    >
      {conversation.repliesToShared && (
        <>
          New teachers will see all existing messages, but they will only be shared on future messages to everyone. They
          will not see later individual replies.
        </>
      )}
      <UserSelector<BasicUser>
        userDescriptor="teachers"
        selectedUsers={sharedUsers}
        extraNames={conversation.alreadyShared}
        setSelectedUsers={setSharedUsers}
        url={'/frontend_api/getTeacherRecipients'}
        searchData={searchData}
      />
      <Button
        logo
        disabled={sharedUsers.length === 0}
        className="self-start"
        onClick={() => {
          setLoading(true)
          makeRequest<void>('/addCCPeople', {
            messageID: conversation.id,
            ccStaff: sharedUsers.map((u) => u.id),
          })
            .then(onShare)
            .catch(showAxiosErrorAsToast)
            .finally(() => setLoading(false))
        }}
      >
        Share
      </Button>
    </ControlledModal>
  )
}
